<template>
	<div class="pt600">
		<breadcrumb :decriptPage="$t('pt600.labels.title')"></breadcrumb>
		<div class="section-inner mb64">
			<h3> {{$t('pt600.labels.inquiryForm')}}</h3>
			<!--送信完了時 -->
			<template v-if="dispalyFlag == 1 || dispalyFlag == 0">
				<ul class="flowchart mb64">
					<!-- 項目の入力 -->
					<li>{{$t('pt600.labels.inputItem')}}</li>
					<!-- 送信完了 -->
					<li class="flow-current">{{$t('pt600.labels.contentSendCompletely')}}</li>
				</ul>
				<div v-html="pt600doInit.descriptionInfo['2']"></div>
			</template>
			<!-- メールアドレス入力画面 -->
			<template v-else>
				<ul class="flowchart mb64">
					<!-- 項目の入力 -->
					<li class="flow-current">{{$t('pt600.labels.inputItem')}}</li>
					<!-- 送信完了 -->
					<li>{{$t('pt600.labels.contentSendCompletely')}}</li>
				</ul>
				<div v-html="pt600doInit.descriptionInfo['1']"></div>
				<!--エラーメッセージ表示 -->
				<template v-if="errorMessage">
					<div class="error-message mb-2">
						<p>{{$t('pt600.labels.errorMsg')}}</p>
					</div>
					<message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="PT600_PART"/>
				</template>
				<template v-if="errFlg == '1'">
					<div v-html="pt600doInit.descriptionInfo['3']"></div>
				</template>
				<template v-else-if="errFlg == '2'">
					<div v-html="pt600doInit.descriptionInfo['4']"></div>
				</template>
				<template v-else-if="errFlg == '3'">
					<div v-html="pt600doInit.descriptionInfo['5']"></div>
				</template>
				<template v-else-if="errFlg == '4'">
					<div v-html="pt600doInit.descriptionInfo['6']"></div>
				</template>
				<input type="hidden" name="pt600ProcessType" id="pt600ProcessType" value="">
				<!-- エラーメッセージ表示-->
				<table class="personal mb32">
				<template>
					<tr>
						<!-- メールアドレス -->
						<th class="required">
							<span id="mail_lbl">{{$t('pt600.labels.mail')}}</span>
						</th>
						<td>
							<input-check v-model="PT600FirstAccessMailPartsReqModel.mail" maxlength="80" size="40" class="mail" id="mail" type="text" />
						</td>
					</tr>
					<tr>
						<th class="required">
							<span id="mail2_lbl">{{$t('pt600.labels.mail2')}}</span>
						</th>
						<td>
							<input-check v-model="PT600FirstAccessMailPartsReqModel.mailKaku" maxlength="80" size="40" class="mail" id="mailKaku"  type="text"/>
						</td>
					</tr>
				</template>
				</table>
				<div id="btn_roll02" class="margin-auto">
					<!-- この内容を送信する -->
					<a @click="confirmSendMail()" >{{$t('pt600.buttons.sendMail')}}</a>
				</div>
			</template>
			<alert-confirm 
				v-if="isModalShow"
				:msgConfirm="msgConfirm"
				:isButtonCancel="isButtonCancel"
				:okAction="sendMail"
				:isButtonOK="isButtonOK">
			</alert-confirm>
		</div>
	</div>
</template>

<script>

import common from "assets/js/common";
import axios from "assets/js/request";
import InputCheck from 'components/InputCheck';
import AlertConfirm from 'components/AlertConfirm';
import Message from 'components/MessageEcSite';
import SiteConstants from 'assets/const/SiteConstants.json';
import EventBus from 'assets/js/eventBus';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
	name: 'PT600FirstAccessMailParts',
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },

	components: {
		InputCheck,
		AlertConfirm,
		Message,
		Breadcrumb
	},

    data() {
        return {
			PT600FirstAccessMailPartsReqModel:{},
            pt600doInit: {
                descriptionInfo:{}
            },
			dispalyFlag:null,
			isModalShow:false,
			msgConfirm:null,
			errorMessage:false,
			listIdErr:[],
            listMessValid:[],
			mapMessValid:[],
			PT600_PART:'pt600',
			SiteConstants:SiteConstants,
			isButtonCancel:false,
			isButtonOK:false,
			errFlg:null
        }
    },
    mounted() {
        var _this = this;
		common.clearMessageEcSite(_this.listIdErr, _this.PT600_PART);

		if (_this.ptInitData){
			_this.pt600doInit = _this.ptInitData;
			_this.PT600FirstAccessMailPartsReqModel = _this.ptInitData.reqModel;
			_this.errorMessage = false;
		}else{
			axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT600 + _this.$UrlConstants.DO_INIT, _this.PT600FirstAccessMailPartsReqModel).then(function(response) {
				_this.pt600doInit = response.data;
				_this.PT600FirstAccessMailPartsReqModel = response.data.reqModel;
				_this.errorMessage = false;
			}).catch(function(error) {
				common.errorAPI(error);
			});
			EventBus.$on('closed', function(){
				_this.isModalShow = false;
			});
		}
	},
	methods: {
        // goto pg030
        sendMail: function(){
			var _this = this;
			_this.isModalShow = false;
			_this.listMessValid = [];
			_this.mapMessValid = [];
			common.clearMessageEcSite(_this.listIdErr, _this.PT600_PART);
			_this.$emit("event-loading", true);
			axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT600 + _this.$UrlConstants.DO_SEND_MAIL, _this.PT600FirstAccessMailPartsReqModel).then(function(response) {
				if(response.data.resultResponse.status == "OK"){
					_this.dispalyFlag = response.data.dispalyFlag;
				}
				_this.isModalShow = false;
				_this.$emit("event-loading", false);
			}).catch(function(error) {
				_this.$emit("event-loading", false);
				_this.errorMessage = true;
				if(error != null && error != undefined){
					_this.isModalShow = false;
					if(error.response != null && error.response != undefined){
						if(406 == error.response.status){
							var resultValid = common.excuteValidationEcSite(error, _this.PT120_PART);
							if(resultValid){
								_this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
								_this.listMessValid = resultValid.msgList;
								_this.mapMessValid = resultValid.mapMsg;
							}
						}else{
							common.errorAPI(error);
						}
					}
				}
				common.scrollTop();
			});
		},
		confirmSendMail: function(){
			var _this = this;
			_this.isModalShow = true;
			//メールアドレスの重複チェック
			axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT600 + _this.$UrlConstants.DO_CHECK, _this.PT600FirstAccessMailPartsReqModel).then(function() {
				// 入力したメールアドレスにメールを送信します。よろしいですか？
				_this.msgConfirm =_this.$i18n.t('pt600.labels.confirmSendMail');
				_this.isButtonCancel=true;
				_this.isButtonOK=true;
			}).catch(function(error) {
				_this.$emit("event-loading", false);
				_this.errorMessage = true;
				if(error != null && error != undefined){
					_this.isModalShow = false;
					if(error.response != null && error.response != undefined){
						if(406 == error.response.status){
							var resultValid = common.excuteValidationEcSite(error, _this.PT120_PART);
							if(resultValid){
								_this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
								_this.listMessValid = resultValid.msgList;
								_this.mapMessValid = resultValid.mapMsg;
							}
						}else{
							common.errorAPI(error);
						}
					}
				}
				common.scrollTop();
			});
		}
	},
    created(){
        var _this = this;
		// Get data from params and query
		var paramData = _this.$route.params;
		if(paramData != null){
			_this.errFlg = paramData.returnErrFlg;
		}
    }
}
</script>